import { PUBLIC_API_URL_ENV } from 'tools/environments';

import {
	GetCityzensProfileError,
	GetCityzensProfileResponse,
} from './types/get-cityzens-profile.type';

export const getCityzensProfile =
	(): Promise<GetCityzensProfileResponse | null> =>
		fetch(`${PUBLIC_API_URL_ENV}/cityzens/profile`, {
			method: 'GET',
			credentials: 'include',
		}).then(async (res) => {
			if (res.ok) {
				return res.json() as Promise<GetCityzensProfileResponse>;
			}

			// Anonymous or expired session — expected on public apps (e.g. players).
			if (res.status === 401) {
				return null;
			}

			const error = new Error(
				`Profile request failed (${res.status})`
			) as GetCityzensProfileError;
			error.status = res.status;
			throw error;
		});
